import React from "react";
import LandingFaq from "../../LandingFaq/LandingFaq";
import { Banner } from "../components/Banner";
import { ContextEdit } from "../components/ContextEdit";
import { ListingCarouselPersuasion } from "../components/ListingCarouselPersuasion";
import { ListingPersuasion } from "../components/ListingPersuasion";
import { MyCashPersuasion } from "../components/MyCashPersuasion";
import {
  PlanCardList,
  type PlanCardListProps,
} from "../components/PlanCardList/PlanCardList";
import { PlansHeader } from "../components/PlansHeader";

/** Same wiring as common landing FAQ — listing `data` uses `title` / `faqList` keys. */
const ListingPageFaq: React.FC<{
  title?: string;
  icon?: string;
  info?: string;
  faqList?: Array<{ ques?: unknown; info?: string }>;
}> = ({ title, icon, info, faqList }) => {
  if (!faqList?.length) return null;
  return (
    <LandingFaq
      customTitle={title}
      faq={faqList as React.ComponentProps<typeof LandingFaq>["faq"]}
      customInfo={info}
      icon={icon}
      isCardView
    />
  );
};

export const COMPONENT_MAPPER: Record<string, React.ComponentType<any>> = {
  COMPONENT_LISTING_PAGE_CONTEXT_EDIT: ContextEdit as React.ComponentType<any>,
  COMPONENT_LISTING_PAGE_MYCASH: MyCashPersuasion as React.ComponentType<any>,
  COMPONENT_LISTING_PAGE_PLANS_HEADER: PlansHeader as React.ComponentType<any>,
  COMPONENT_LISTING_PAGE_MYP_MWEB_TRIP_CARDS:
    PlanCardList as React.ComponentType<any>,
  COMPONENT_LISTING_PAGE_PWA_TRIP_CARDS: PlanCardList as React.ComponentType<any>,
  COMPONENT_LISTING_PAGE_TRIP_CARDS: PlanCardList as React.ComponentType<any>,
  COMPONENT_LISTING_PAGE_BANNER: Banner as React.ComponentType<any>,
  COMPONENT_LISTING_PAGE_CAROUSEL_PERSUASION:
    ListingCarouselPersuasion as React.ComponentType<any>,
  COMPONENT_LISTING_PERSUASION: ListingPersuasion as React.ComponentType<any>,
  COMPONENT_LISTING_PAGE_FAQ: ListingPageFaq as React.ComponentType<any>,
};

export type ListingTemplateId = keyof typeof COMPONENT_MAPPER;

export type { PlanCardListProps };
